import { render, staticRenderFns } from "./SharedEmailAddressForm.vue?vue&type=template&id=52b00398&"
import script from "./SharedEmailAddressForm.vue?vue&type=script&lang=ts&"
export * from "./SharedEmailAddressForm.vue?vue&type=script&lang=ts&"
import style0 from "./SharedEmailAddressForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
